import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { CompanyDetailsButton } from '../buttons';
import CompanyBlacklistComponent from './CompanyBlacklistComponent';
import CompanyDebtsSummary from './CompanyDebtsSummary';
import CompanyRiskStatusTooltip from '../tooltips/CompanyRiskStatusTooltip';
import LineClampText from '../typography/LineClampText';

const CompanyCell = ({
  company,
  showDetails,
  showBlacklist,
  showDebtsSummary,
  showCompanyRiskStatus,
  type,
  titleVariant,
  titleFontWeight,
  subtitleVariant,
}) => {
  const { id, name, displayNationalIdentifier } = company;

  return (
    <Stack width="100%" alignItems="flex-start" justifyContent="center">
      <Stack direction="row">
        <LineClampText
          text={name}
          maxLines={1}
          variant={titleVariant}
          width="inherit"
          fontWeight={titleFontWeight}
        />
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <LineClampText
          text={displayNationalIdentifier}
          maxLines={1}
          variant={subtitleVariant}
          color="gray.A400"
          width="inherit"
        />
        {showCompanyRiskStatus && (<CompanyRiskStatusTooltip masterEntity={company} />)}
        {showBlacklist && (
          <CompanyBlacklistComponent masterEntity={company} disableDisplay />
        )}
        {showDebtsSummary && (
          <CompanyDebtsSummary masterEntity={company} type={type} />
        )}
      </Stack>
      {showDetails && <CompanyDetailsButton companyId={id} />}
    </Stack>
  );
};

CompanyCell.propTypes = {
  type: PropTypes.oneOf(['company', 'receiver']),
  company: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    displayNationalIdentifier: PropTypes.string.isRequired,
    riskBlacklist: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  showBlacklist: PropTypes.bool,
  showDetails: PropTypes.bool,
  showDebtsSummary: PropTypes.bool,
  titleVariant: PropTypes.string,
  titleFontWeight: PropTypes.number,
  subtitleVariant: PropTypes.string,
  showCompanyRiskStatus: PropTypes.bool,
};

CompanyCell.defaultProps = {
  type: 'company',
  showBlacklist: false,
  showDetails: false,
  showDebtsSummary: false,
  titleFontWeight: 600,
  titleVariant: 'body2',
  subtitleVariant: 'caption',
  showCompanyRiskStatus: false,
};

export default CompanyCell;
